import React from 'react';
import webapi from '../../../api/webapi';

import OwlCarousel from 'react-owl-carousel'; 
import 'owl.carousel/dist/assets/owl.carousel.css';  
import 'owl.carousel/dist/assets/owl.theme.default.css';

import Img2 from './img2';

class TopBooks extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            TopBooks: undefined,
            ParsigTextShow:undefined
        };
    }
    
    componentDidMount() {
        this.getPage();
    }

    async getPage() {
        //console.log('LanguageInfo[0]:'+this.props.LanguageInfo[0].Code);
        const TopBooksConst = await webapi.get('book/topbooks/'+this.props.LanguageInfo[0].Code);
        //console.log(TopBooksConst.data[0].FormStatusCode==='BS_Loading');
        //console.log(this.props.pageData);
        this.setState({
            TopBooks: TopBooksConst.data
        });

        const PageConfigConst = await webapi.get('pages/config/1/'+this.props.LanguageInfo[0].Code);
        
        //console.log(PageConfigConst);
        this.setState({
            ParsigTextShow: PageConfigConst.data.filter((val)=>{
                    if(val.Item.toLowerCase()==='ParsigTextShow'.toLowerCase()){
                        return val;
                    }
                    else
                    {
                        return null;
                    }
                })
        })
        //console.log(PageConfigConst.data[0]);
    }

    render() {
        if (this.state.ParsigTextShow && this.state.ParsigTextShow.length>0 && this.state.ParsigTextShow[0].Value==='1' && 
            this.props.pageData && this.props.LanguageInfo){
            return (
                <div className="container-fluid" id="firstpage_row_4" style={{direction:'ltr'}}>
                    <div className="container">
                        <div id="firstpage_row_4_text">
                            <h4>{this.props.pageData.length!==0 && this.props.pageData[0].F102!== undefined?this.props.pageData[0].F102:102/*متون پارسیگ*/}</h4>
                            <hr />
                            <OwlCarousel    items={4}  
                                            className="owl-theme"  
                                            //loop  
                                            autoplay
                                            rewind
                                            autoplayTimeout={8000}
                                            autoplayHoverPause
                                            margin={30} >  
                                {
                                    (this.state.TopBooks && this.state.TopBooks.length>0)
                                    ?
                                        this.state.TopBooks.map((topbook) =>{
                                            return  (
                                                <div key={topbook.Code}>
                                                    {/* {
                                                    <img alt="a" className="new_badge" src= {new_badge} /> 
                                                    } */}
                                                    {
                                                        (topbook.FormStatusCode.toLowerCase()==="bs_loading")
                                                        ?
                                                        <span className="new_badge">{this.props.pageData.length!==0 && this.props.pageData[0].F10205!== undefined?this.props.pageData[0].F10205:10205/*جدید*/}</span>
                                                        :
                                                        null
                                                    }
                                                    <Img2 
                                                        Class="book_img"
                                                        ImageCode={topbook.Code}
                                                    />
                                                    <p className="book_title">
                                                        <a href={"/book/"+topbook.Code}>{topbook.Title}</a>
                                                    </p>
                                                    <p className="book_summary">{topbook.Note}</p>
                                                    <p className="book_stat">{topbook.Description}</p>
                                                    <p className="book_number"><span className="circle">{topbook.Field2}</span></p>
                                                    <br/> 
                                                    <br/>
                                                </div>
                                            )
                                        })
                                    :
                                    null
                                }
                            </OwlCarousel> 
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

export default TopBooks;